import { useEffect, useCallback } from "react";
import { useLazyGetResidentsIndexQuery } from "app/services/api/residentsApi";
import { OfflinePrefetchProps } from "../interface";
import { useDispatch } from "react-redux";
import {
  usePrefetchUtils,
  executePaginatedPrefetch,
} from "../utils/usePrefetchUtils";
import {
  setResidentsIndexResponse,
  setResidentsPrefetched,
} from "app/store/slices/residents";
import { store } from "app/services/store";

export function usePrefetchResidents({ enabled }: OfflinePrefetchProps) {
  const dispatch = useDispatch();
  const [trigger] = useLazyGetResidentsIndexQuery();

  const handlePrefetch = useCallback(async () => {
    await executePaginatedPrefetch({
      name: "Residents",
      trigger,
      buildQueryArgs: (page) => ({ page, filter: {} }),
      storeData: (data) => dispatch(setResidentsIndexResponse(data)),
      getLastPage: (data) => data?.meta?.last_page ?? 1,
      enableSmartCache: true,
      getFirstRecordId: (data) => data?.data?.[0]?.id ?? null,
      dispatch,
      getState: () => store.getState(),
    });
  }, [trigger, dispatch]);

  const { hasPrefetchedAll } = usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });

  useEffect(() => {
    dispatch(setResidentsPrefetched(hasPrefetchedAll));
  }, [hasPrefetchedAll, dispatch]);
}
